import React, { Fragment, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { GQLJobState, GQLParty } from '@jewelutions/core-crm-server-api-client-domain';

import { Chip, JwlTable, LoadingSpinner } from '../../../../components';
import { GQLOperationBuilder } from '../../../../operations/GQLOperationBuilder';
import { PlatformNavigation } from '../../navigation/PlatformNavigation';

interface IProps {
  party: GQLParty;
}

const JobList: React.FC<IProps> = ({ party }: IProps) => {
  const history = useHistory();
  const [filteredJobs, setFilteredJobs] = useState('');
  const { t: translate } = useTranslation();

  const { data: partiesData, loading: partiesLoading } = GQLOperationBuilder.party.getPartiesByPlatform({});
  const { data: jobsData, loading: jobsLoading } = GQLOperationBuilder.job.getAllJobSummaries({});

  if (partiesLoading || jobsLoading) return <LoadingSpinner />;
  const parties = GQLOperationBuilder.party.partyArrayFromResponse(partiesData);
  const jobs = GQLOperationBuilder.job.jobSummaryArrayFromResponse(jobsData);

  const handleFilterChange = (event: any) => setFilteredJobs(event.target.value);

  const getJobsRows = () => {
    return jobs
      .filter(job => {
        return (
          job.state.toLowerCase().includes(filteredJobs.toLowerCase().trim()) ||
          job.type.toLowerCase().includes(filteredJobs.toLowerCase().trim())
        );
      })
      .map(job => {
        const jobParty = parties.find(p => p.id === job.partyId);
        return {
          id: job.id,
          cells: [
            job.id,
            job.type,
            [GQLJobState.FinishedFailed, GQLJobState.FinishedSuccess].includes(job.state) ? (
              <Chip
                size="small"
                mr={1}
                mb={1}
                label={job.state}
                $active={GQLJobState.FinishedFailed !== job.state}
              />
            ) : (
              job.state
            ),
            jobParty!.name,
            new Date(Date.parse(job.createdAt)).toLocaleString(),
            job.startedAt ? new Date(Date.parse(job.startedAt)).toLocaleString() : 'NOT STARTED',
            job.finishedAt ? new Date(Date.parse(job.finishedAt)).toLocaleString() : 'NOT FINISHED'
          ]
        };
      });
  };

  const navigateToPartyDetails = (jobId: string) => {
    history.push(
      PlatformNavigation.jobDetails.pathFromParams({
        jobId: jobId
      })
    );
  };

  return (
    <Fragment>
      <JwlTable
        title="Platform jobs list"
        description={`The list of all jobs defined in the platform.`}
        columns={['ID', 'Type', 'State', 'Party', 'Created at', 'Started at', 'Finished at']}
        rows={getJobsRows()}
        onFilterChange={handleFilterChange}
        onTableRowClick={navigateToPartyDetails}
      />
    </Fragment>
  );
};

export default JobList;
